export const APPLICATION_ORDER_STATES = {
	1: "pending",
	2: "success",
	3: "danger",
	4: "warning",
	5: "info",
	6: "neutral",
};

export const getApplicationOrderStateVariant = (stateId) => {
	return APPLICATION_ORDER_STATES[stateId] || "neutral";
};
